module.exports = __webpack_public_path__ + "img/11.92ff6bc3.png";